import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {UigEmptyCartComponent} from '../components/uig-cart/uig-empty-cart/uig-empty-cart.component';

export const uigEmptyCartComponentDialogLayoutConfig: LayoutConfig = {
    launch: {
        EMPTY_CART: {
            inlineRoot: true,
            component: UigEmptyCartComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};
